import React from 'react';
import { Navigate } from "react-router";

const PrivateRoute = ({ isAuthenticated, children }) => {
    return isAuthenticated ? children : <Navigate to="/" />;
  };
export default PrivateRoute;